// extracted by mini-css-extract-plugin
export default {"button":"DuplicateWarningIcon_button__DBwBS","warning":"DuplicateWarningIcon_warning__cff-5","icon":"DuplicateWarningIcon_icon__qt7-P"};